


































import { Component, Vue } from 'vue-property-decorator'
import { navigation } from '@/store/modules'
import config from '@/config'

interface Link {
  label: string;
  href: string;
}

declare const VERSION: string
declare const LASTCOMMITDATETIME: string

@Component
export default class About extends Vue {
  readonly webappVersion: string = VERSION
  readonly lastCommitDateTime: string = LASTCOMMITDATETIME

  get links (): Link[] {
    return [
      { label: 'Nos partenaires', href: `${config.orrm.siteURL}/partenaires` },
      { label: 'A propos', href: `${config.orrm.siteURL}/qui-sommes-nous` },
      { label: 'Politique de confidentialité', href: `${config.orrm.siteURL}/protection-des-donnees-personnelles` },
      { label: 'Contactez-nous', href: `${config.orrm.siteURL}/contact` }
    ]
  }

  get orrmUrl (): string {
    return config.orrm.siteURL
  }

  get lastUpdate (): string {
    return (new Date(this.lastCommitDateTime)).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })
  }

  get version (): string {
    if (this.webappVersion.startsWith('v')) {
      return this.webappVersion.substring(1)
    }
    return this.webappVersion
  }

  onClose () {
    navigation.setAboutOpen(false)
  }
}
